import React from 'react';
import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, small: PropTypes.bool };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    small: false,
};

class Cross extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            small,
        } = this.props;
        return [
            's-cross',
            small ? 's-cross_size_small' : false,
            className,
        ];
    }

    renderChildren() {
        return (
            <>
                <div className="s-cross__element s-cross__element_top" />
                <div className="s-cross__element s-cross__element_bottom" />
            </>
        );
    }

}

Cross.propTypes = propTypes;

Cross.defaultProps = defaultProps;

export default Cross;
